import { cn, Icon, type MarketIconSymbol, TabItem, Tabs } from "@kyan/ui";

import { marketList } from "#/config/markets";
import { usePositionsDrawerMarket } from "#/store/app/positionsDrawer/positionsDrawerMarket";
import { useAccountState } from "#/store/wallet/account/accountState";
import { AccountStateByPortfolioSymbol } from "#/types/accounts";
import { Market, UnderlyingSymbol } from "#/types/markets";

const getTabs = (
  market: Market,
  accountState: AccountStateByPortfolioSymbol,
): TabItem<UnderlyingSymbol>[] =>
  marketList.map((item) => {
    const isActive = item.underlying === market.underlying;
    const isLiquidated = accountState[item.underlying].isLiquidated;

    return {
      id: item.underlying,
      label: (
        <div
          className={cn(
            "relative flex items-center justify-center gap-1 transition-colors",
            {
              "text-error": isActive && isLiquidated,
            },
          )}
        >
          <Icon
            size="lg"
            name={item.underlying.toLowerCase() as MarketIconSymbol}
          />
          <span>{item.underlying}</span>
          <div
            className={cn(
              "bg-error absolute -top-1 right-1.5 size-1 rounded-full opacity-0 transition-opacity",
              {
                "opacity-100": !isActive && isLiquidated,
              },
            )}
          />
        </div>
      ),
    };
  });

export const MarketSwitch: React.FC = () => {
  const { accountState } = useAccountState();
  const { market, setMarketByUnderlying } = usePositionsDrawerMarket();

  const tabs = getTabs(market, accountState);

  return (
    <Tabs
      items={tabs}
      variant="primary"
      value={market.underlying}
      itemClassName="h-10.25 text-xs w-18 min-w-18"
      onChange={setMarketByUnderlying}
    />
  );
};
